var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ma-2",attrs:{"close":"","color":_vm.color},on:{"click:close":_vm.removeValue}},[_vm._v(" "+_vm._s(_vm.format(_vm.value))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }